var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllJobsGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11V9.5H14V11H4.5ZM4.5 6.75V5.25H14V6.75H4.5ZM4.5 2.5V1H14V2.5H4.5ZM1.49558 11.75C1.08186 11.75 0.729167 11.6027 0.4375 11.3081C0.145833 11.0135 0 10.6593 0 10.2456C0 9.83186 0.147306 9.47917 0.441917 9.1875C0.736542 8.89583 1.09071 8.75 1.50442 8.75C1.91814 8.75 2.27083 8.89731 2.5625 9.19192C2.85417 9.48654 3 9.84071 3 10.2544C3 10.6681 2.85269 11.0208 2.55808 11.3125C2.26346 11.6042 1.90929 11.75 1.49558 11.75ZM1.49558 7.5C1.08186 7.5 0.729167 7.3527 0.4375 7.05808C0.145833 6.76346 0 6.40929 0 5.99558C0 5.58186 0.147306 5.22917 0.441917 4.9375C0.736542 4.64583 1.09071 4.5 1.50442 4.5C1.91814 4.5 2.27083 4.64731 2.5625 4.94192C2.85417 5.23654 3 5.59071 3 6.00442C3 6.41814 2.85269 6.77083 2.55808 7.0625C2.26346 7.35417 1.90929 7.5 1.49558 7.5ZM1.49558 3.25C1.08186 3.25 0.729167 3.10269 0.4375 2.80808C0.145833 2.51346 0 2.15929 0 1.74558C0 1.33186 0.147306 0.979167 0.441917 0.6875C0.736542 0.395833 1.09071 0.25 1.50442 0.25C1.91814 0.25 2.27083 0.397306 2.5625 0.691917C2.85417 0.986542 3 1.34071 3 1.75442C3 2.16814 2.85269 2.52083 2.55808 2.8125C2.26346 3.10417 1.90929 3.25 1.49558 3.25Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllJobsGray);
export default __webpack_public_path__ + "static/media/all_jobs_gray.583c6a15c2446de31a3153c11ac0de5e.svg";
export { ForwardRef as ReactComponent };